import React from "react";
import notFound from "@/assets/svg/404.svg";
import Image from "next/image";

const PageNotFound = () => {
  return (
    <div style={{ width: "40%", margin: "60px auto" }}>
      <Image src={notFound} alt="" />
    </div>
  );
};

export default PageNotFound;
